import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'status';

const statusService = {
  getStatus: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/statuses`,
      data,
    });
  },

  createStatus: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateStatus: (data, statusId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(statusId)}`,
      data,
    });
  },

  createStatusItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/statusItem`,
      data,
    });
  },

  deleteStatusItem: (statusItemId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/statusItem/${encodeURIComponent(statusItemId)}`,
    });
  },

  updateStatusItem: (data, statusId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/statusItem/${encodeURIComponent(statusId)}`,
      data,
    });
  },

  updateDefaultValue: (id, itemId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/defaultValue/${encodeURIComponent(id)}/${encodeURIComponent(itemId)}`,
    });
  },

  updateOnKanban: (itemId, onKanban) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/onKanban/${encodeURIComponent(itemId)}`,
      data: { onKanban: onKanban },
    });
  },

  orderStatusItem: (itemId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orderStatusItem/${encodeURIComponent(itemId)}`,
      data,
    });
  },
};

export default statusService;
